import { createSelector } from 'reselect';
//////////////////////////////////////////////////

const store = (state) => state.templates;

const makeSelectItemTemplates = () => createSelector(
  store,
  ({ items }) => items,
);

const makeSelectLocationTemplates = () => createSelector(
  store,
  ({ locations }) => locations,
);

const makeSelectContainerTemplates = () => createSelector(
  store,
  ({ containers }) => containers,
);

export {
  store,
  makeSelectItemTemplates,
  makeSelectLocationTemplates,
  makeSelectContainerTemplates,
};
